
import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Button,
} from "@mui/material";
import { FaCloudUploadAlt, FaFilePdf } from "react-icons/fa";
import { useDropzone } from "react-dropzone";
import LoadingScreen from "../../component/LoadingScreen";


function TerminationFeedback() {
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const [error, setError] = useState('');
    const [terminationDetail, setTerminationDetail] = useState({ terminationItemlist: [], terminationFeedbackList: [] });
    const [buttonClicked, setButtonClicked] = useState('');
    const [openConfirmApprove, setOpenConfirmApprove] = useState(false);
    const [openConfirmFeedback, setOpenConfirmFeedback] = useState(false);
    const [notes, setNotes] = useState('');
    const [customerByToken, setCustomerByToken] = useState('');
    const [tokenUser, setTokenUser] = useState('');

    const resource = "termination-feedback";
    const storedToken = localStorage.getItem("token");

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);

    const XCPTTS_003 = 3
    const showApproval = terminationDetail.xcp_termination_status === XCPTTS_003;
    const fileTypes = [
        "image/png", // .png
        "image/jpeg",// .jpg/.jpeg
    ];


    const [files, setFiles] = useState([]);
    const [uploadedFiles, setUploadedFiles] = useState([]); // Track uploaded files
    const [uploadProgress, setUploadProgress] = useState({}); // Track upload progress
    const [isUploading, setIsUploading] = useState(false);
    const maxSize = 5 * 1024 * 1024;
    const [errorUpload, setErrorUpload] = useState("");

    // Your S3 upload Lambda endpoint
    const filetype = 'termination-evidence'
    const onDrop = useCallback((acceptedFiles) => {
        setErrorUpload(""); // Clear previous errors

        if (acceptedFiles.length === 0) {
            setErrorUpload("No files selected");
            return;
        }
        if (acceptedFiles.length > 5) {
            setErrorUpload("Too many files");
            return;
        }

        acceptedFiles.forEach((file, index) => {
            // Validate file type
            if (!fileTypes.includes(file.type)) {
                setErrorUpload(prev => {
                    const newError = `${file.name}: Invalid file type, allowed file types .png, .jpg`;
                    return prev ? `${prev}; ${newError}` : newError;
                });
                return;
            }

            // Validate file size
            if (file.size > maxSize) {
                setErrorUpload(prev => {
                    const newError = `${file.name}: File size exceeds 5MB`;
                    return prev ? `${prev}; ${newError}` : newError;
                });
                return;
            }

            // Check for duplicates and add file one by one
            setFiles(prevFiles => {
                const isDuplicate = prevFiles.some(existingFile =>
                    existingFile.name === file.name &&
                    existingFile.size === file.size &&
                    existingFile.lastModified === file.lastModified
                );

                if (isDuplicate) {
                    setErrorUpload(prev => {
                        const newError = `${file.name}: File already exists`;
                        return prev ? `${prev}; ${newError}` : newError;
                    });
                    return prevFiles; // Don't add duplicate
                }

                // Add single file to array (one by one)
                return [...prevFiles, file];
            });
        });
    }, []);

    const removeFile = useCallback((indexToRemove) => {
        setFiles(prevFiles => prevFiles.filter((_, index) => index !== indexToRemove));
    }, []);

    // Helper function to clear all files
    const clearAllFiles = useCallback(() => {
        setFiles([]);
        setUploadedFiles([]);
        setUploadProgress({});
        setErrorUpload("");
    }, []);

    // Function to upload files to S3
const uploadFilesToS3 = async () => {
    if (files.length === 0) {
        setErrorUpload("No files to upload");
        return false;
    }

    setIsUploading(true);
    setErrorUpload(""); // Clear previous errors
    const terminationId = terminationDetail.termination_id;
    const username = customerByToken.xcp_internal_email;

    try {
        const uploadPromises = files.map(async (file, index) => {
            console.log(file);
            try {
                // Use encodeURIComponent to handle special characters in filename
                
                
                const presignedResponse = await axios.get(
                    `https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/termination/upload-termination-feedback?terminationId=${terminationId}&fileName=${file.name}&fileType=${file.type}&username=${username}`
                );
                
                console.log(presignedResponse.data.uploadUrl);
                
                // Check if the response indicates success
                

                console.log(file.type)
                // Upload file to S3
                const uploadResponse = await axios.put(presignedResponse.data.uploadUrl, file, {
                    headers: {
                        'Content-Type': file.type,
                    },
                    timeout: 30000, 
                });
                
                if (uploadResponse.status === 200) {
                    console.log(`Successfully uploaded: ${file.name}`);
                    return {
                        success: true,
                        fileName: file.name,
                        index: index
                    };
                } else {
                    throw new Error(`Failed to upload file to S3. Status: ${uploadResponse.status}`);
                }
            } catch (error) {
                console.error(`Error uploading ${file.name}:`, error);
                return {
                    success: false,
                    fileName: file.name,
                    error: error.response?.data?.message || error.message || 'Unknown error',
                    index: index
                };
            }
        });

        const results = await Promise.all(uploadPromises);
        
        // Process results
        const successful = results.filter(r => r.success);
        const failed = results.filter(r => !r.success);

        if (successful.length > 0) {
            console.log(`Successfully uploaded ${successful.length} file(s)`);
        }

        if (failed.length > 0) {
            const errorMessages = failed.map(f => `${f.fileName}: ${f.error}`).join('; ');
            setErrorUpload(`Failed to upload ${failed.length} file(s): ${errorMessages}`);
        } else {
            setErrorUpload(""); // Clear error if all uploads successful
        }

        setIsUploading(false);
        return failed.length === 0; // Return true if all uploads were successful

    } catch (error) {
        console.error('Error in uploadFilesToS3:', error);
        setErrorUpload('Failed to upload files: ' + (error.response?.data?.message || error.message));
        setIsUploading(false);
        return false;
    }
};

    const { getRootProps, getInputProps } = useDropzone({
        onDrop,
        accept: fileTypes.join(","),
        multiple: true,
        validator: null,
    });

    useEffect(() => {
        const checkSessionToken = async () => {
            try {
                const response = await fetch(
                `https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/auth/check-session?token=${storedToken}&resource=${resource}`,
                {
                    method: "GET",
                    headers: {
                    "Content-Type": "application/json",
                    authorization: "Basic eGNwOk50dGkyMDI0IQ==",
                    },
                }
                );

                if (!response.ok) {
                    setError(data.message || "Failed to fetch session token data");
                    throw new Error(data.message || "Failed to fetch session token data");
                }

                // Parse response text as a boolean value
                const text = await response.text();
                const data = text === "true";

                if (data) {
                } else {
                    window.alert("Session is invalid");
                    navigate("/login");
                }
            } catch (error) {
                console.error("Fetch Error:", error.message);
                setError("Fetch Error: " + error.message);
            }
        };

        checkSessionToken();
    }, []);

    useEffect(() => {
        loadTerminationDetail(searchParams.get('param1'));
    }, []);

    const loadTerminationDetail = async (terminationId) => {
        try {       
        const result = await axios.get(`https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/termination/termination-detail?terminationId=${terminationId}`, {
              headers: {
                authorization: 'Basic eGNwOk50dGkyMDI0IQ==',
              },
            });
        const data = result.data;

            setTerminationDetail(data);
        } catch (error) {
        console.error("Error loading termination list:", error);
        }
    };

    const formatDate = (datetime) => {
        const date = new Date(datetime);
        const year = date.getUTCFullYear(); // Gunakan UTC
        const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Gunakan UTC
        const day = String(date.getUTCDate()).padStart(2, '0'); // Gunakan UTC
        return `${day}/${month}/${year}`;
    };

    function getCurrenDate() {
        const date = new Date();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();

        let currentDate = `${day}/${month}/${year}`;
        return currentDate
    }

    useEffect(() => {
        // Retrieve the token from local storage  
        const storedToken = localStorage.getItem('token');
        if (storedToken) {
            loadUserByToken(storedToken);
        }
        setTokenUser(storedToken);
    }, []);

    const loadUserByToken = async (token1) => {
        const result = await axios.get(`https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/auth/find-by-token?token=${token1}`, {
              headers: {
                authorization: 'Basic eGNwOk50dGkyMDI0IQ==',
              },
            });
        setCustomerByToken(result.data[0])
    }

    function getCurrenDateForDb() {
        const date = new Date();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();

        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');

        let currentDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        return currentDate
    }

    const handleClose = () => {
        setOpenConfirmApprove(false);
        setOpenConfirmFeedback(false);
    };

    const handleSubmit = async (event) => {
        // Upload files first if there are any
       
        event.preventDefault(); // Prevent default form submission
        setIsLoading(true);
        setError(''); // Clear previous errors
    
        try {
            // Upload files first if there are any
             if (customerByToken.xcp_role_code === "XCPRLE-004") {

                 if (files.length > 0) {
                     console.log('Starting file upload...');
                     const uploadSuccess = await uploadFilesToS3();
                     if (!uploadSuccess) {
                         setError('Failed to upload some files. Please try again.');
                         
                         setIsLoading(false);
                         return;
                     }
                     console.log('File upload completed successfully');
                 }
            }

            // Validate feedback notes if feedback button was clicked
            if (!notes && buttonClicked === "feedback") {
                setOpenConfirmFeedback(false);
                setError('Please enter Feedback Note!');
                setIsLoading(false);
                return;
            }

        const userName = customerByToken.xcp_internal_email;
        const terminationId = terminationDetail.termination_id;
        const currentDate = getCurrenDateForDb();
        const token = tokenUser;

        console.log('Submitting termination feedback...', {
            userName,
            terminationId,
            buttonClicked,
            feedbackDate: currentDate
        });

        const response = await fetch('https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/termination/termination-feedback', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': "Basic eGNwOk50dGkyMDI0IQ==", // Fixed capitalization
            },
            body: JSON.stringify({
                userName: userName,
                terminationId: terminationId,
                feedback: notes,
                buttonClicked: buttonClicked,
                feedbackDate: currentDate,
                token: token
            }),
        });

        console.log('Response status:', response.status);
        console.log('Response ok:', response.ok);

        if (!response.ok) {
            const errorText = await response.text();
            console.error('Response error:', errorText);
            setError(`Server error: ${response.status} ${response.statusText}`);
            setIsLoading(false);
            return;
        }

        const data = await response.json();
        console.log('Response data:', data);

        // Handle different response formats
        let responseBody;
        let statusCode;

        if (data.body) {
            // If response has a body property that needs parsing
            try {
                responseBody = JSON.parse(data.body);
                statusCode = data.statusCode;
            } catch (parseError) {
                console.error('Error parsing response body:', parseError);
                responseBody = data.body;
                statusCode = data.statusCode || response.status;
            }
        } else {
            // Direct response format
            responseBody = data;
            statusCode = data.statusCode || response.status;
        }

        console.log('Parsed response:', { responseBody, statusCode });

        if (statusCode !== 200) {
            const errorMessage = responseBody?.message || responseBody?.error || 'Unknown server error';
            setError(errorMessage);
            setIsLoading(false);
            return;
        }

        // Success case
        console.log('Submission successful!');
        setError("");
        setIsLoading(false);
        
        // Close any open confirmation dialogs
        setOpenConfirmApprove(false);
        setOpenConfirmFeedback(false);
        
        // Navigate to the target page
        navigate('/termination-list');

    } catch (error) {
        console.error('Submit Error:', error);
        setError(`Failed to submit: ${error.message}`);
        setIsLoading(false);
    }
    }

    const handleConfirmation = async (event) => {
        event.preventDefault();
        if (buttonClicked === "approve") {
            setOpenConfirmApprove(true);
        } else if (buttonClicked === "feedback") {
            setOpenConfirmFeedback(true);
        }
    };



    return (
        <div className='container-order-input'>
            {isLoading && <LoadingScreen />}
            <h1 className='main-title'>Cross Connect Termination Feedback</h1> 
            <div className="order-information-order-input">
                <div className='title-order-input'>                            
                    <h5>Termination Information</h5>  
                </div>                      
                <div className="textbox-gray">
                        <label htmlFor="terminationDate">Termination Date</label>
                        <input type="text" placeholder={formatDate(terminationDetail.termination_date)} disabled/>
                    </div>
                    <div className="textbox-gray">
                        <label htmlFor="terminationPic">Termination PIC</label>
                        <input type="text" placeholder={terminationDetail.termination_pic} disabled/>
                    </div>
            </div>

    {terminationDetail.terminationItemlist && terminationDetail.terminationItemlist.length > 0 && terminationDetail.terminationItemlist.map((termination, index) => (
    <div>
        <div className='box-two-part'>           
            <div className="requestor-information">                  
                    <div className="textbox-gray">
                        <label htmlFor="companyName">Cable Id</label>
                        <input type="text" placeholder={termination.cable_id} disabled/>
                    </div>
                    <div className="textbox-gray">
                        <label htmlFor="picName">Company Name Requestor</label>
                        <input type="text" placeholder={termination.company_requestor} disabled/>
                    </div>
                    <div className="textbox-gray">
                        <label htmlFor="contactEmail">PIC Name Requestor</label>
                        <input type="text" placeholder={termination.pic_requestor} disabled/>
                    </div>
                    <div className="textbox-gray">
                        <label htmlFor="orderDate">Order Date</label>
                        <input type="text" placeholder={formatDate(termination.order_date)} disabled/>
                    </div>
                    <div className="textbox-gray">
                        <label htmlFor="comboBox" className='requestLocation'>Request Location</label>
                        <select id="comboBox" name="options" disabled>
                        <option value="option1">{termination.order_location_name}</option>
                        </select>
                    </div>       
                    <div className="radio-button">
                        <label>Cross Connect Type</label>
                        <div className="radio-button-option">
                            <input type="radio" name={`connect-${index}`} id="connect-one" 
                            checked={termination.order_type_id === 1} 
                            disabled/>
                            <label htmlFor={`connect-one-${index}`}>Interconnection to other tenant device</label>
                        </div>
                        <div className="radio-button-option">
                            <input type="radio" name={`connect-${index}`} id="connect-two" 
                            checked={termination.order_type_id === 2}
                            disabled/>
                            <label htmlFor={`connect-two-${index}`}>Interconnection to your own device</label>
                        </div>
                    </div>         
            </div>

            <div className="destination-information">        
                    <div className="textbox-gray">
                        <label htmlFor="cableStatus">Cable Status</label>
                        <input type="text" placeholder={termination.cable_status} disabled/>
                    </div>
                    <div className="textbox-gray">
                        <label htmlFor="installationDate">Installation Date</label>
                        <input type="text" placeholder={formatDate(termination.order_date)} disabled/>
                    </div>
                    <div className="textbox-gray">
                        <label htmlFor="companyNameDestination">Company Name Destination</label>
                        <input type="text" placeholder={termination.company_destination} disabled/>
                    </div>       
                    <div className="textbox-gray">
                        <label htmlFor="picNameDestination">PIC Name Destination</label>
                        <input type="text" placeholder={termination.pic_destination} disabled/>
                    </div>     
                    <div className="textbox-gray">
                        <label htmlFor="salesOrderNumber">Sales Order Number</label>
                        <input type="text" placeholder={termination.sales_order_no} disabled/>
                    </div>          
                    
            </div>                
        </div>
        
         <div className='box-two-part'>          
            <div className="a-end-information">
                <div className="title-box-order-input">
                    <h5>A-end Information</h5>
                </div>         
                <div className="textbox-gray">
                    <label htmlFor="comboBox">Cable Type</label>
                    <select id="comboBox" name="options" disabled>
                        <option value="option1">{termination.cable_type_a}</option>  
                    </select>
                    </div>
                    <div className="textbox-gray">
                    <label htmlFor="comboBox">Interface</label>
                    <select id="comboBox" name="options" disabled>
                        <option value="option1">{termination.interface_name_a}</option>  
                    </select>
                    </div>
                    <div className="textbox-gray">
                    <label htmlFor="comboBox">Floor</label>
                    <select id="comboBox" name="options" disabled>
                        <option value="option1">{termination.floor_name_a}</option>  
                    </select>
                    </div>
                    <div className="textbox-gray">
                    <label htmlFor="comboBox">Room</label>
                    <select id="comboBox" name="options" disabled>
                        <option value="option1">{termination.room_name_a}</option>  
                    </select>
                    </div>   
                    <div className="textbox-gray">
                        <label htmlFor="rackId">Rack ID</label>
                        <input type="text" placeholder={termination.a_end_rack_id} disabled/>
                    </div>
                    <div className="textbox-gray">
                        <label htmlFor="cableQuantity">Cable Quantity</label>
                        <input type="text" placeholder={termination.cable_quantity} disabled/>
                    </div>
            </div>

            <div className="b-end-information">
                <div className="title-box-order-input">
                    <h5>B-end Information</h5>
                </div>         
                <div className="textbox-gray">
                    <label htmlFor="comboBox">Cable Type</label>
                    <select id="comboBox" name="options" disabled>  
                        <option value="option1">{termination.cable_type_b}</option>              
                    </select>
                    </div>
                    <div className="textbox-gray">
                    <label htmlFor="comboBox">Interface</label>
                    <select id="comboBox" name="options" disabled>
                        <option value="option1">{termination.interface_name_b}</option>
                    </select>
                    </div>
                    <div className="textbox-gray">
                    <label htmlFor="comboBox">Floor</label>
                    <select id="comboBox" name="options" disabled>
                        <option value="option1">{termination.floor_name_b}</option>
                    </select>
                    </div>
                    <div className="textbox-gray">
                    <label htmlFor="comboBox">Room</label>
                    <select id="comboBox" name="options" disabled>
                        <option value="option1">{termination.room_name_b}</option>                      
                    </select>  
                    </div>               
                    <div className="textbox-gray">
                        <label htmlFor="rackId">Rack ID</label>
                        <input type="text" placeholder={termination.b_end_rack_id} disabled/>
                    </div>                 
            </div>    
        </div>
    </div>
    ))}  
 
        <div className='box-two-part'>      
            <div className='feedback-history'>
                <h5>Termination Feedback History</h5>
                <table class="table table-bordered">
                       <thead>
                            <tr>
                            <th scope="col">Date</th>
                            <th scope="col">User</th>
                            <th scope="col" className="note-column">Note</th>
                            </tr>
                        </thead>
                        <tbody>                        
                        {terminationDetail.terminationFeedbackList.map((termination) => (
                            <tr>
                                <td>{formatDate(termination.feedback_date)}</td>
                                <td>{termination.username}</td>
                                <td className="note-column">{termination.feedback}</td>
                            </tr>
                           ))}   
                        </tbody>
                    </table> 
                </div>               
            </div>
        {customerByToken.xcp_role_code === 'XCPRLE-004' && 
            <div className="box-feedback">
            <label className="uploadApprovalLetterLable">Upload Termination Evidence</label>
            <div {...getRootProps()} className="dropzone-termination">
                <input {...getInputProps()} />
                <FaCloudUploadAlt size={50} color="#007bff" />
                <p>
                    Drag and drop files (max 5MB each) here, or click to select multiple files. 
                    Maximum 5 files allowed. Accepted file types: .png, .jpg
                </p>
            </div>
            
                <div className="files-header">
                    <p>Selected Files ({files.length}/5):</p>
                </div>
            {files.length > 0 && (
                <div className="files-info-container">
                
                <div className="files-list">
                   
                    {files.map((file, index) => (

                        <div class="file-item">
                            <span class="file-name">{index + 1}. {file.name}</span>
                            <button class="remove-btn" onClick={() => removeFile(index)} aria-label="Remove file"></button>

                        </div>
                    ))}
                </div>
            </div>
            )}
            {errorUpload && <p className="error-message">{errorUpload}</p>}                
            
        </div>
        }
            <div className='box-two-part'>
                <form onSubmit={handleConfirmation}>
                    <div className="feedback-order">    
                        <div className="title-box-order-input">
                            <h5>Termination Feedback</h5>
                        </div>                        
                        <div className="textbox-gray">
                            <label htmlFor="currentDate">Date</label>
                            <input type="text" placeholder={getCurrenDate()} disabled/>
                        </div>
                        <div className="textbox-gray">
                            <label htmlFor="user">User</label>
                            <input type="text" placeholder={customerByToken.xcp_internal_email} disabled/>
                        </div>
                        <div className="textbox">
                            <label htmlFor="Note">Note</label>
                            <textarea
                            value={notes} 
                            onChange={(e) => setNotes(e.target.value)}
                            placeholder='Note'                          
                        ></textarea>  
                        </div>    
                        {error && <p className="error-message">{error}</p>}
                        {/* className={!showApproval ? 'disabled-icon' : ''} */}
                        <input type="submit" className="btn-submit-order-approval-two" value="Approve" 
                            onClick={() => setButtonClicked("approve")} />
                        {showApproval && (
                        <input type="submit" className="btn-submit-order-feedback" value="Submit Feedback" 
                            onClick={() => setButtonClicked("feedback")}/>  
                        )}                      
                    </div>    
                </form>                 
            </div> 
            <Dialog open={openConfirmApprove}>
                    <DialogTitle>{"Are you sure you want to approve this termination?"}</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                Clicking "Yes" will approve this termination.
                            </DialogContentText>
                        </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose} color="primary">
                            No
                        </Button>
                        <Button onClick={handleSubmit} color="primary" autoFocus>
                            Yes
                        </Button>
                    </DialogActions>
                </Dialog>   
                <Dialog open={openConfirmFeedback}>
                    <DialogTitle>{"Are you sure you want to submit feedback for this termination?"}</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                Clicking "Yes" will submit feedback for this termination.
                            </DialogContentText>
                        </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose} color="primary">
                            No
                        </Button>
                        <Button onClick={handleSubmit} color="primary" autoFocus>
                            Yes
                        </Button>
                    </DialogActions>
                </Dialog> 
        </div>
    );
}

export default TerminationFeedback;
